var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cleaning home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cleaning_home",
    "data-name": "Cleaning home"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,46H45V20a3.45,3.45,0,0,0,3-3.45c0-2.36-1.89-3.14-4-4.52V4a1,1,0,0,0-1-1H37a1,1,0,0,0-1,1V6.86L26.73.81a5,5,0,0,0-5.46,0L1.59,13.64A3.52,3.52,0,0,0,3,20.06V46H2a1,1,0,0,0,0,2H46A1,1,0,0,0,46,46ZM38,5h4v5.77L38,8.16ZM2,16.59c0-1.17-.84-.27,20.36-14.1a3,3,0,0,1,3.28,0L45.31,15.32a1.51,1.51,0,0,1-1.65,2.53L24.55,5.39c-.8-.52.38-1-20.21,12.46A1.51,1.51,0,0,1,2,16.59ZM15,36H13V19a1,1,0,0,1,1.71-.69C15.13,18.71,15,17.59,15,36Zm2,2a1,1,0,0,1,1,1v1H10V39a1,1,0,0,1,1-1ZM9.18,46l.67-4h8.3l.67,4ZM38,31a1,1,0,1,1-.14,2H32V31Zm-8,5H27V30h3Zm-5-3H22a1,1,0,0,1,0-2h3Zm-.29,13a1,1,0,0,1-1-.92L22.94,35H25v2a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V35h4.78L36,45.08A1,1,0,0,1,35,46Zm13.11,0c.22-.6.11.14,1-11.12A3,3,0,0,0,38,29H31.72c-.76-1.3-2-1-4.72-1a2,2,0,0,0-1.72,1H22a3,3,0,0,0-1.08,5.79l.8,10.44c.08,1,.62.77-.87.77-1-6.1-.85-4.44-.85-7a3,3,0,0,0-3-3V19a3,3,0,0,0-6,0V36a3,3,0,0,0-3,3c0,2.56.17.9-.85,7H5c0-29.17-.19-26.07.43-26.47L24,7.42,42.57,19.53c.61.4.43-2.73.43,26.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/cleaning.14f3a9b2442853677c09914e81543f55.svg";
export { ForwardRef as ReactComponent };